import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import React, { useEffect, useState } from 'react';
import relationships from 'Consts/Relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import View from './View';

const LIABILITY_ACCOUNT = 'liability';

const Controller = () => {
  const { householdResource } = useSimpleHousehold();
  const [accountsCollection, setAccountsCollection] = useState();

  const getAccountsOfType = (accountType) => {
    if (!accountsCollection) {
      return [];
    }
    const result = accountsCollection.resources().list().filter(account => account.attr('accountType') === accountType);
    return result !== undefined ? result : [];
  };

  const refreshAccounts = async () => {
    return householdResource.relationship(relationships.accounts).link('related').get()
      .then((newAccountsCollection) => {
        newAccountsCollection.fetchAllPages().then(col => setAccountsCollection(col));
      });
  };

  useEffect(() => {
    if (householdResource !== undefined) {
      refreshAccounts()
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  return (
    <View
      liabilities={getAccountsOfType(LIABILITY_ACCOUNT)}
    />
  );
};
Controller.propTypes = {
};

export default Controller;
